import React from "react";

/**
 * @component EyeSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <EyeSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const EyeSmallIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="EyeSmallIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M6 4.4c.904 0 1.636.716 1.636 1.6 0 .884-.732 1.6-1.636 1.6-.904 0-1.636-.716-1.636-1.6 0-.884.732-1.6 1.636-1.6M6 2c2.727 0 5.056 1.659 6 4-.944 2.341-3.273 4-6 4S.944 8.341 0 6c.944-2.341 3.273-4 6-4M1.19 6C2.09 7.792 3.95 8.933 6 8.933S9.91 7.792 10.81 6C9.91 4.208 8.05 3.067 6 3.067S2.09 4.208 1.19 6z"
        fillRule="evenodd"
      />
    </svg>
  )
);
EyeSmallIcon.displayName = "EyeSmallIcon";
export default EyeSmallIcon;
